import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 17"
}, r = /* @__PURE__ */ o("path", {
  fill: "currentColor",
  d: "M9.135.25C5.202.25 1.97 3.256 1.654 7.087H.865A.615.615 0 0 0 .432 8.14l1.379 1.367a.615.615 0 0 0 .866 0L4.056 8.14a.615.615 0 0 0-.434-1.053H2.89c.31-3.143 2.985-5.606 6.245-5.606A6.28 6.28 0 0 1 14.5 4.47a.615.615 0 1 0 1.048-.645A7.51 7.51 0 0 0 9.135.25m7.19 6.742a.616.616 0 0 0-.865 0L14.076 8.36a.616.616 0 0 0 .432 1.054h.738c-.314 3.142-2.996 5.606-6.272 5.606a6.32 6.32 0 0 1-5.387-2.99.615.615 0 1 0-1.048.647 7.55 7.55 0 0 0 6.435 3.574c3.945 0 7.192-3.003 7.507-6.837h.795a.615.615 0 0 0 .432-1.054z"
}, null, -1), c = [
  r
];
function l(a, s) {
  return e(), t("svg", n, [...c]);
}
const d = { render: l };
export {
  d as default,
  l as render
};
